/*
 * Copyright (c) 2026 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

/**
 * Extracts the display labels for an ObjectDescription member's allowed values, supporting both
 * plain value arrays and ListManager-style {label, description} object arrays.
 */
export function extractAllowedValueLabels(member: any): string[] {
    if (!member?.allowedValues || !Array.isArray(member.allowedValues) || member.allowedValues.length === 0) {
        return [];
    }
    const isListManagerStructure = member.allowedValues[0] &&
                                   typeof member.allowedValues[0] === 'object' &&
                                   'label' in member.allowedValues[0] &&
                                   'description' in member.allowedValues[0];
    if (isListManagerStructure) {
        return member.allowedValues.map((item: any) => item.label);
    }
    return member.allowedValues.map((item: any) => String(item));
}

/**
 * Finds a member by memberName within an ObjectDescription's members array and extracts its
 * allowed value labels.
 */
export function extractAllowedValueLabelsForMember(members: any[], memberName: string): string[] {
    const member = members?.find((m: any) => m.memberName === memberName);
    return extractAllowedValueLabels(member);
}
